var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.activeStep
        ? _c(
            "mds-button",
            {
              attrs: { variation: "flat" },
              on: {
                click: function ($event) {
                  return _vm.onClick()
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.translate("scheduler.modal.cancel.button")) +
                  "\n  "
              ),
            ]
          )
        : _c(
            "mds-button",
            {
              attrs: { icon: "angle-left", variation: "flat" },
              on: {
                click: function ($event) {
                  return _vm.$emit("back-step")
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.translate("scheduler.modal.back.button")) +
                  "\n  "
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }